import React from 'react';
import logo from './Img/logo.svg';
import me from './Img/Me.jpeg'
import javaScriptIcon from './Img/javaScriptLogo.png'
import html from './Img/html.png'
import css from './Img/cssLogo.png'
import './App.css';
import {makeStyles, MuiThemeProvider} from '@material-ui/core/styles';
import ApplicationBar from "./Components/ApplicationBar";
import Typography from "@material-ui/core/Typography";
import Typical from 'react-typical'
import { AwesomeButton } from "react-awesome-button";
import "react-awesome-button/dist/styles.css";
import {Parallax, ParallaxLayer} from "react-spring/renderprops-addons";
import IntroPage from "./Components/IntroPage";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  container:{
    position: "relative",
    width: 500,
  }
}));

class App extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        document.title = 'MewersDev'
    }

    render() {
    return (
        <div>
            <meta name="viewport" content="initial-scale=1, width=device-width, height=device-height, viewport-fit=cover"/>

            <ApplicationBar/>
            <IntroPage/>
        </div>



    );
  }
}
export default App;
